// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"142":"71fe5a77","297":"a9d968d2","498":"a8eb8fe4","643":"e97e51b2","703":"42160a27"}[chunkId] + ".chunk.js";
};